import {
  inputPrompts,
  requestErrors,
  approvalsGroupText,
} from './approvals_group_text';

export const requestTypes = {
  INITIAL_LOAD: 'INITIAL_LOAD',
  USER_REQUEST: 'USER_REQUEST',
  SUBMIT_GROUP: 'SUBMIT_GROUP',
  GROUP_STATUS: 'GROUP_STATUS',
  DELETE_GROUP: 'DELETE_GROUP',
};

export const initialGroupState = {
  formUpdated: false,
  initialGroupName: '',
  nameInput: '',
  nameMaxLength: 0,
  nameIsValid: true,
  nameErrMsg: requestErrors.uniqueName,
  descriptionInput: '',
  descriptionMaxLength: 0,
  admins: [],
  adminsCount: 0,
  adminsSelectionCount: 0,
  adminsIsValid: true,
  adminsErrMsg: inputPrompts.addGroupAdmin,
  approvers: [],
  approversCount: 0,
  approversSelectionCount: 0,
  approversIsValid: true,
  users: [],
  usersCount: 0,
  usersSelectionCount: 0,
  usersIsValid: true,
  selectUsersModal: {
    showModal: false,
    title: '',
    cta: '',
    users: [],
    userCount: 0,
    modalSelectionCount: 0,
    currentSelectionCount: 0,
    selectAllUsers: false,
    orderByName: false,
    orderByLimit: false,
    actionType: '',
  },
  removeUserModal: {
    showModal: false,
    userType: '',
    userId: '',
    title: '',
    description:
      'The account administrator will receive all approval requests for users not assigned to a group.',
    cta: 'Remove',
  },
  groupStatus: {
    status: '',
    messaging: {
      title: '',
      body: '',
    },
    canDelete: null,
  },
  routes: {
    changeStatusUrl: '',
    createGroupUrl: '',
    formRedirectUrl: '',
  },
  request: {
    status: true,
    type: requestTypes.INITIAL_LOAD,
    params: '',
  },
};

export const approvalRoles = {
  ADMIN: 'administrator',
  APPROVER: 'approver',
  USER: 'standard',
};

export const requestParams = {
  ADMINS_ROLE: `?role=${approvalRoles.ADMIN}`,
  APPROVERS_ROLE: `?role=${approvalRoles.APPROVER}`,
  USERS_ROLE: '', // No params get both users and approver roles
};

export const groupActions = {
  FORM_UPDATED: 'FORM_UPDATED',
  FORM_REDIRECT_URL: 'FORM_REDIRECT_URL',
  UPDATE_GROUP_STATUS: 'UPDATE_GROUP_STATUS',
  UPDATE_GROUP_STATUS_URL: 'UPDATE_GROUP_STATUS_URL',
  UPDATE_CREATE_GROUP_URL: 'UPDATE_CREATE_GROUP_URL',
  INITITAL_GROUP_NAME: 'INITIAL_GROUP_NAME',
  NAME_INPUT: 'NAME_INPUT',
  NAME_ISVALID: 'NAME_ISVALID',
  NAME_INVALID: 'NAME_INVALID',
  DESCRIPTION_INPUT: 'DESCRIPTION_INPUT',
  ADMINS_ISVALID: 'ADMINS_ISVALID',
  ADMINS_INVALID: 'ADMINS_INVALID',
  UPDATE_ALL_ADMINS: 'UPDATE_ALL_ADMINS',
  UPDATE_ALL_APPROVERS: 'UPDATE_ALL_APPROVERS',
  UPDATE_ALL_USERS: 'UPDATE_ALL_USERS',
  CREATE_USER_MODAL: 'CREATE_USER_MODAL',
  UPDATE_USER_MODAL: 'UPDATE_USER_MODAL',
  SORT_BY_NAME_MODAL: 'SORT_BY_NAME_MODAL',
  SORT_BY_LIMIT_MODAL: 'SORT_BY_LIMIT_MODAL',
  SELECT_ALL_USER_MODAL: 'SELECT_ALL_USER_MODAL',
  CLEAR_ALL_USER_MODAL: 'CLEAR_ALL_USER_MODAL',
  SELECT_ALL_STATUS_MODAL: 'SELECT_ALL_STATUS_MODAL',
  RESET_USER_MODAL: 'RESET_USER_MODAL',
  OPEN_MESSAGE_MODAL: 'OPEN_MESSAGE_MODAL',
  REMOVE_MESSAGE_MODAL: 'REMOVE_MESSAGE_MODAL',
  ADD_USERS_REQUEST: 'ADD_USERS_REQUEST',
  UPDATE_USERS_REQUEST: 'UPDATE_USERS_REQUEST',
  ERROR_USERS_REQUEST: 'ERROR_USERS_REQUEST',
  INITIAL_LOAD_REQUEST: 'INITIAL_LOAD_REQUEST',
  ENABLE_REQUEST: 'ENABLE_REQUEST',
  DISABLE_REQUEST: 'DISABLE_REQUEST',
};

const filterSelectedUsers = usersList =>
  usersList.filter(user => user.selected);

const selectAllUsers = (usersList, filteredList, status) => {
  for (let i = 0; i < filteredList.length; i++) {
    for (let k = 0; k < usersList.length; k++) {
      if (filteredList[i].customer_id === usersList[k].customer_id) {
        usersList[k].selected = status;
      }
    }
  }
};

const deselectAllUsers = usersList => {
  usersList.forEach(user => {
    user.selected = false;
  });
};

const findUserIndex = (users, customerId) =>
  users.map(user => user.customer_id).indexOf(customerId);

const removeSelectedUser = (users, customerId) => {
  const userIndex = findUserIndex(users, customerId);
  users[userIndex].selected = !users[userIndex].selected;
};

const addSelectedUsers = (selectedUsers, users) => {
  if (selectedUsers.length === 0) return users;

  const selectedUsersIds = selectedUsers.reduce((acc, user) => {
    if (user.selected) {
      acc.push(user.customer_id);
    }
    return acc;
  }, []);

  users.forEach(user => {
    if (selectedUsersIds.includes(user.customer_id)) {
      user.selected = true;
    }
  });
  return users;
};

const selectionCount = users =>
  users.reduce((acc, user) => {
    if (user.selected) {
      acc++;
    }
    return acc;
  }, 0);

export const approvalsGroupReducer = (state, action) => {
  const updatedState = { ...state };

  switch (action.type) {
    case groupActions.FORM_UPDATED:
      if (!updatedState.formUpdated) {
        updatedState.formUpdated = true;
      }
      break;
    case groupActions.FORM_REDIRECT_URL:
      updatedState.routes.formRedirectUrl = action.payload;
      break;
    case groupActions.UPDATE_GROUP_STATUS:
      updatedState.groupStatus.status = action.payload.status;
      updatedState.groupStatus.messaging = action.payload.messaging;
      updatedState.groupStatus.canDelete = action.payload.canDelete;
      break;
    case groupActions.UPDATE_GROUP_STATUS_URL:
      updatedState.routes.changeStatusUrl = action.payload.change_status_url;
      break;
    case groupActions.UPDATE_CREATE_GROUP_URL:
      updatedState.routes.createGroupUrl = action.payload;
      break;
    case groupActions.INITITAL_GROUP_NAME:
      updatedState.initialGroupName = action.payload;
      break;
    case groupActions.NAME_INPUT:
      updatedState.nameInput = action.payload;
      break;
    case groupActions.NAME_ISVALID:
      updatedState.nameIsValid = true;
      updatedState.nameErrMsg = action.payload;
      break;
    case groupActions.NAME_INVALID:
      updatedState.nameIsValid = false;
      updatedState.nameErrMsg = action.payload;
      break;
    case groupActions.DESCRIPTION_INPUT:
      updatedState.descriptionInput = action.payload;
      break;
    case groupActions.ADMINS_ISVALID:
      updatedState.adminsIsValid = true;
      updatedState.adminsErrMsg = action.payload;
      break;
    case groupActions.ADMINS_INVALID:
      updatedState.adminsIsValid = false;
      updatedState.adminsErrMsg = action.payload;
      break;
    case groupActions.UPDATE_ALL_ADMINS:
      updatedState.admins = action.payload;
      updatedState.adminsSelectionCount = selectionCount(action.payload);
      updatedState.adminsIsValid = action.payload.some(admin => admin.selected);
      break;
    case groupActions.UPDATE_ALL_APPROVERS:
      updatedState.approvers = action.payload;
      updatedState.approversSelectionCount = selectionCount(action.payload);
      break;
    case groupActions.UPDATE_ALL_USERS:
      updatedState.users = action.payload;
      updatedState.usersSelectionCount = selectionCount(action.payload);
      break;
    case groupActions.CREATE_USER_MODAL:
      updatedState.selectUsersModal = action.payload;
      break;
    case groupActions.SORT_BY_NAME_MODAL:
      updatedState.selectUsersModal.orderByName =
        !updatedState.selectUsersModal.orderByName;
      updatedState.selectUsersModal.orderByLimit = false;
      updatedState.selectUsersModal.users.sort((a, b) => {
        const currentName = `${a.forename} ${a.surname}`;
        const nextName = `${b.forename} ${b.surname}`;
        if (currentName < nextName) {
          return updatedState.selectUsersModal.orderByName ? -1 : 1;
        }
        if (currentName > nextName) {
          return updatedState.selectUsersModal.orderByName ? 1 : -1;
        }
        return 0;
      });
      break;
    case groupActions.SORT_BY_LIMIT_MODAL: {
      updatedState.selectUsersModal.orderByLimit =
        !updatedState.selectUsersModal.orderByLimit;

      updatedState.selectUsersModal.orderByName = false;

      let sortValue = '';
      if (
        updatedState.selectUsersModal.cta === approvalsGroupText.approvers.cta
      ) {
        sortValue = 'max_approval_limit';
      }
      if (updatedState.selectUsersModal.cta === approvalsGroupText.users.cta) {
        sortValue = 'credit_limit';
      }

      if (updatedState.selectUsersModal.orderByLimit) {
        updatedState.selectUsersModal.users.sort(
          (a, b) => a[sortValue] - b[sortValue],
        );
      } else {
        updatedState.selectUsersModal.users.sort(
          (a, b) => b[sortValue] - a[sortValue],
        );
      }

      break;
    }
    case groupActions.UPDATE_USER_MODAL: {
      removeSelectedUser(updatedState.selectUsersModal.users, action.payload);

      updatedState.selectUsersModal.modalSelectionCount = filterSelectedUsers(
        updatedState.selectUsersModal.users,
      ).length;
      const { userCount, modalSelectionCount } = updatedState.selectUsersModal;
      updatedState.selectUsersModal.selectAllUsers =
        userCount === modalSelectionCount;
      break;
    }
    case groupActions.SELECT_ALL_USER_MODAL: {
      selectAllUsers(
        updatedState.selectUsersModal.users,
        action.payload,
        !updatedState.selectUsersModal.selectAllUsers,
      );
      updatedState.selectUsersModal.modalSelectionCount = filterSelectedUsers(
        updatedState.selectUsersModal.users,
      ).length;
      updatedState.selectUsersModal.selectAllUsers =
        !updatedState.selectUsersModal.selectAllUsers;
      break;
    }
    case groupActions.CLEAR_ALL_USER_MODAL:
      deselectAllUsers(updatedState.selectUsersModal.users);
      updatedState.selectUsersModal.modalSelectionCount = 0;
      updatedState.selectUsersModal.selectAllUsers = false;
      break;
    case groupActions.SELECT_ALL_STATUS_MODAL: {
      const selectedUsers = action.payload.filter(user => user.selected).length;
      updatedState.selectUsersModal.selectAllUsers =
        action.payload.length === selectedUsers;
      break;
    }
    case groupActions.RESET_USER_MODAL:
      updatedState.selectUsersModal = initialGroupState.selectUsersModal;
      break;
    case groupActions.OPEN_MESSAGE_MODAL: {
      updatedState.removeUserModal.showModal = true;
      updatedState.removeUserModal.userType = action.payload.title;
      const { forename, surname } = action.payload.user;
      updatedState.removeUserModal.userId = action.payload.user.customer_id;
      updatedState.removeUserModal.title = /* HTML */ `Are you sure you would
      like to remove ${forename} ${surname} from this group?`;
      break;
    }
    case groupActions.REMOVE_MESSAGE_MODAL:
      if (
        updatedState.removeUserModal.userType ===
        approvalsGroupText.admins.title
      ) {
        removeSelectedUser(
          updatedState.admins,
          updatedState.removeUserModal.userId,
        );
        updatedState.adminsSelectionCount--;
        updatedState.adminsCount = updatedState.adminsSelectionCount;
      }
      if (
        updatedState.removeUserModal.userType ===
        approvalsGroupText.approvers.title
      ) {
        removeSelectedUser(
          updatedState.approvers,
          updatedState.removeUserModal.userId,
        );
        updatedState.approversSelectionCount--;
      }
      if (
        updatedState.removeUserModal.userType === approvalsGroupText.users.title
      ) {
        removeSelectedUser(
          updatedState.users,
          updatedState.removeUserModal.userId,
        );
        updatedState.usersSelectionCount--;
      }
      updatedState.removeUserModal.showModal = false;
      break;
    case groupActions.CLOSE_MESSAGE_MODAL:
      updatedState.removeUserModal.showModal = false;
      break;
    case groupActions.ADD_USERS_REQUEST:
      if (updatedState.request.params === requestParams.ADMINS_ROLE) {
        updatedState.admins = addSelectedUsers(
          updatedState.admins,
          action.payload,
        );
        updatedState.adminsIsValid = true;
      }
      if (updatedState.request.params === requestParams.APPROVERS_ROLE) {
        updatedState.approvers = addSelectedUsers(
          updatedState.approvers,
          action.payload,
        );
        updatedState.approversIsValid = true;
      }
      if (updatedState.request.params === requestParams.USERS_ROLE) {
        updatedState.users = addSelectedUsers(
          updatedState.users,
          action.payload,
        );
        updatedState.usersIsValid = true;
      }
      updatedState.selectUsersModal.users = JSON.parse(
        JSON.stringify(action.payload),
      );
      break;
    case groupActions.UPDATE_USERS_REQUEST:
      updatedState.selectUsersModal = action.payload;
      break;
    case groupActions.ERROR_USERS_REQUEST:
      if (updatedState.request.params === requestParams.ADMINS_ROLE) {
        updatedState.adminsIsValid = false;
        updatedState.adminsErrMsg = requestErrors.error;
      }
      if (updatedState.request.params === requestParams.APPROVERS_ROLE) {
        updatedState.approversIsValid = false;
      }
      if (updatedState.request.params === requestParams.USERS_ROLE) {
        updatedState.usersIsValid = false;
      }
      updatedState.selectUsersModal.showModal = false;
      break;
    case groupActions.INITIAL_LOAD_REQUEST:
      updatedState.nameMaxLength = action.payload.nameMaxLength;
      updatedState.descriptionMaxLength = action.payload.descriptionMaxLength;
      updatedState.adminsCount = action.payload.adminsCount;
      updatedState.approversCount = action.payload.approversCount;
      updatedState.usersCount = action.payload.usersCount;
      // updatedState.inititalLoadRequest = false;
      break;
    case groupActions.ENABLE_REQUEST:
      updatedState.request = {
        status: true,
        type: action.payload.type,
        params: action.payload.params,
      };
      break;
    case groupActions.DISABLE_REQUEST:
      updatedState.request = { status: false, type: '', params: '' };
      break;
    default:
      // eslint-disable-next-line no-console
      console.error('Reducer action not found:', action.type);
  }

  return updatedState;
};
